import loadable from '@loadable/component'

export default {
  '/question-group/problem-sets': loadable(() => import('./ProblemSets')),
  '/questions/answer-analysis': loadable(() => import('./AnswerAnalysis'))
}
